import graphQl from '@/services/graphQl';
import { AxiosResponse } from 'axios';
import { Commit, ActionTree, Dispatch } from 'vuex';
import { State } from './pages.store';

const actions: ActionTree<State, any> = {
  GET_PAGES_META_DATA(context: { commit: Commit }, params: any): Promise<void> {
    return new Promise((resolve, reject) => {
      if (params) {
        graphQl
          .query('queryMetaData')
          .params(params)
          .then((res: AxiosResponse<any>) => {
            if (!res.data.data) {
              console.error(res.data);
              throw Error(res.data);
            } else {
              context.commit('setPagesMetaData', [
                res.data.data.response.records,
                res.data.data.response.total
              ]);
              resolve();
            }
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      }
    });
  }
};

export default actions;
